import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { PageHeader, Empty } from "@/components/PageHeader";
import { Button } from "@/components/ui/button";
import { ArrowLeft, Loader2, Users, ExternalLink } from "lucide-react";

export default function ClientSearchDetail() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [s, setS] = useState(null);
  useEffect(() => { api.get(`/client/searches/${id}`).then(({ data }) => setS(data)).catch(() => {}); }, [id]);
  if (!s) return <div className="h-screen flex items-center justify-center"><Loader2 className="h-6 w-6 animate-spin text-muted-foreground" /></div>;
  return (
    <div>
      <PageHeader overline={`${s.role_type} · ${s.status}`} title={s.title}>
        <Button variant="ghost" onClick={() => navigate("/client/searches")} className="rounded-none"><ArrowLeft className="h-4 w-4 mr-1" /> Back</Button>
      </PageHeader>
      <div className="p-8 space-y-8">
        {(s.search_brief || s.location || s.compensation_range) && (
          <div className="border border-black/10 bg-white p-6">
            <p className="overline mb-3">Search brief</p>
            <p className="text-sm text-[#27272A] leading-relaxed">{s.search_brief || s.description || "—"}</p>
            <div className="flex flex-wrap gap-x-10 gap-y-2 mt-4">
              {s.location && <div><span className="overline text-[0.55rem] mr-2">Location</span><span className="text-sm">{s.location}</span></div>}
              {s.compensation_range && <div><span className="overline text-[0.55rem] mr-2">Comp</span><span className="text-sm">{s.compensation_range}</span></div>}
            </div>
          </div>
        )}
        <div>
          <p className="overline mb-4">Shared shortlist</p>
          {s.shortlist.length === 0 && <Empty icon={Users} title="No candidates shared yet" hint="Your recruiter will share candidates here as the search progresses." />}
          {s.shortlist.length > 0 && (
            <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-px bg-black/10 border border-black/10">
              {s.shortlist.map((sc) => {
                const c = sc.candidate;
                return (
                  <div key={sc.id} className="bg-white p-5">
                    <div className="flex items-start justify-between">
                      <div className="h-10 w-10 bg-black/5 flex items-center justify-center font-heading font-bold">{c.full_name.charAt(0)}</div>
                      <span className="overline text-[0.55rem]">{sc.stage}</span>
                    </div>
                    <h3 className="font-heading font-bold mt-4">{c.full_name}</h3>
                    <p className="text-sm text-muted-foreground">{c.headline || "—"}</p>
                    {c.location && <p className="text-xs text-muted-foreground mt-1">{c.location}</p>}
                    <p className="text-sm text-[#27272A] mt-3 line-clamp-3">{c.summary || ""}</p>
                    {c.resume_file_url && (
                      <a href={`${process.env.REACT_APP_BACKEND_URL}${c.resume_file_url}`} target="_blank" rel="noreferrer" className="mt-3 inline-flex items-center gap-1 text-sm text-primary hover:underline">
                        <ExternalLink className="h-3.5 w-3.5" /> Resume
                      </a>
                    )}
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
